import { render, staticRenderFns } from "./LayoutPageMenu.vue?vue&type=template&id=f1305b04&scoped=true"
import script from "./LayoutPageMenu.vue?vue&type=script&lang=js"
export * from "./LayoutPageMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutPageMenu.vue?vue&type=style&index=0&id=f1305b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1305b04",
  null
  
)

export default component.exports